import styled from 'styled-components';
import { Image } from 'grommet';

export const StyledSvgImage = styled(Image)<{ color?: string }>`
  fill: ${({ color }) => color || 'black'};
  stroke: ${({ color }) => color || 'black'};
`;
